import { NavLink, Outlet, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultBiller, getWorkflowSteps } from "compid/workflows/AddBillerLong";

import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";

import InfoAlertNotificationView from "compid/shared/views/Notifications/InfoNotificationView/components/InfoAlertNotificationView";
import "./styles.css";

export default function AddBillerPage(props) {
  // Set the active routes for the company and person links
  const companyRoutes = [ "/addBiller/addCompany", "/addBillerLongWorkflow/addCompany" ];
  const personRoutes = [ "/addBiller/addPerson", "/addBillerLongWorkflow/addPerson" ];
  // Initalize the workflow step, and check if the workflow property is defined
  const workflowStep = useWorkflowStep(getDefaultBiller, getWorkflowSteps);
  const hasWorkflow = !(workflowStep.workflow === undefined || workflowStep.workflow === null);
  // If the current context is not within a workflow, then route to the pages directly
  const companyClick = hasWorkflow ? "/addBillerLongWorkflow/addCompany" : "/addBiller/addCompany";
  const personClick = hasWorkflow ? "/addBillerLongWorkflow/addPerson" : "/addBiller/addPerson";

  return (
    <PageView className="add-biller">
      <p className="page-sub-header semi-bold-text">ADD BILLER</p>

      <PageLayoutContainer>
        <CenterColumnContainer>
          <InfoAlertNotificationView 
            className="verify-biller-info-notification"
            text="Please verify the biller information and account number with the biller statement to avoid any payment delays." />

          <div className="tabs-container flex-container align-center add-biller-tabs">
            <NavLink className="tab-item flex-width text-center" activeClassName="active-tab"
            activeRoutes={ companyRoutes } to={ companyClick } dataPoint="Company">
              <span className="tab-text">Company</span>
            </NavLink>
            <NavLink className="tab-item flex-width flex-width text-center" activeClassName="active-tab"
            activeRoutes={ personRoutes } to={ personClick } dataPoint="Person">
              <span className="tab-text">Person</span>
            </NavLink>
          </div>
          <Outlet/>
        </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  )
}